import { api } from "./client";
import type { UserMe } from "@/types";

export async function register(
  email: string,
  password: string,
  language: "en" | "ru" | "uk" | "es" | "de" | "fr" | "it" | "pt" | "sv" | "da" = "en",
): Promise<UserMe> {
  // Phase 24.7.1: autodetect browser timezone for per-user date bucketing.
  let timezone = "UTC";
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    timezone = "UTC";
  }

  const { data } = await api.post<UserMe>("/auth/register", {
    email,
    password,
    language,
    timezone,
  });
  return data;
}

export async function login(email: string, password: string): Promise<string> {
  const { data } = await api.post<{ access_token: string }>("/auth/login", {
    email,
    password,
  });
  return data.access_token;
}

export async function me(): Promise<UserMe> {
  const { data } = await api.get<UserMe>("/auth/me");
  return data;
}

export async function requestPasswordReset(email: string): Promise<void> {
  await api.post("/auth/password-reset/request", { email });
}

export async function confirmPasswordReset(
  token: string,
  new_password: string,
): Promise<void> {
  await api.post("/auth/password-reset/confirm", { token, new_password });
}

export async function changePassword(
  current_password: string,
  new_password: string,
): Promise<void> {
  await api.post("/auth/password-change", { current_password, new_password });
}
